import { gql } from '@apollo/client'

const RETRY_JOB = gql`
  mutation RetryJob($jobId: String!) {
    retryJob(jobId: $jobId) {
      success
      newJobId
      error
    }
  }
`

export default RETRY_JOB
